import React, { useMemo } from 'react';

const ImageBannerPlayer = ({
  hours = 0,
  minutes = 0,
  seconds = 0,
  url = '',
  playing = false,
  onEnded,
  onDuration,
  className = ''
}) => {
  const [paused, setPaused] = React.useState(playing);
  const [over, setOver] = React.useState(false);
  const [[h, m, s], setTime] = React.useState([hours, minutes, seconds]);
  const [imgUrl, setImgUrl] = React.useState('');

  const tick = () => {
    if (paused || over) return;
    if (h === 0 && m === 0 && s === 0) setOver(true);
    else if (m === 0 && s === 0) {
      setTime([h - 1, 59, 59]);
    } else if (s == 0) {
      setTime([h, m - 1, 59]);
    } else {
      setTime([h, m, s - 1]);
    }
  };

  const reset = () => {
    setTime([parseInt(hours), parseInt(minutes), parseInt(seconds)]);
    setPaused(false);
    setOver(false);
  };

  React.useEffect(() => {
    if (over) {
      reset();
      onEnded();
    }
  }, [over]);

  React.useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  React.useEffect(() => {
    setPaused(playing);
  }, [playing]);

  const getModifiedImageUrl = useMemo(
    () => () => {
      let transformation = `?tr=pr=true,c-at_max`;
      // console.log('inside image banner player', transformation, url);
      if (url && typeof url == 'string' && !url.includes('https')) {
        let splittedImg = url?.split('/');
        let path_extracted_image = splittedImg[splittedImg?.length - 1];
        const cfImageUrl = `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT_ID}/${path_extracted_image}${transformation}`;
        // console.log('inside image banner player in if', path_extracted_image, cfImageUrl);
        return cfImageUrl;
      } else if (url && typeof url == 'string' && url.includes('https://storage.googleapis.com/')) {
        const temp_image_name = url.replace('https://storage.googleapis.com/', '');
        const cfImageUrl = `https://ik.imagekit.io/${process.env.REACT_APP_IMAGEKIT_ID}/${temp_image_name}${transformation}`;
        // console.log('inside image banner player in else if', temp_image_name, cfImageUrl);
        return cfImageUrl;
      } else {
        return url;
      }
    },
    [url]
  );

  React.useEffect(() => {
    setImgUrl(getModifiedImageUrl());
  }, [url]);

  React.useEffect(() => {
    setImgUrl(getModifiedImageUrl());
  }, [onEnded]);

  React.useEffect(() => {
    onDuration(`${seconds - s.toString().padStart(2, '0')}`);
  }, [h, m, s]);

  return (
    <>
      {imgUrl && (
        <img
          src={imgUrl}
          alt="banner image"
          importance="high"
          className={className ?? ''}
          style={{ width: '100%' }}
        ></img>
      )}
      {/* {
        <p>{`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s
          .toString()
          .padStart(2, '0')}`}</p>
      }{' '}
      <div>{over ? "Time's up!" : ''}</div>
      <button onClick={() => setPaused(!paused)}>{paused ? 'Resume' : 'Pause'}</button>
      <button onClick={() => reset()}>Restart</button> */}
    </>
  );
};
export default React.memo(ImageBannerPlayer);
